import { atom } from "recoil";

export const showScriptsSubmoduleState = atom({
  key: "showScriptsSubmoduleState",
  default: false,
});

export const submoduleDatas = atom({
  key: "submoduleDatas",
  default: [],
});

export const inputValueState = atom({
  key: "inputValueState",
  default: "",
});

export const resetSubmoduleDataState = atom({
  key: "resetSubmoduleDataState",
  default: false,
});
